<template>
    <div id="confirmationPaymentPopup" class="modal fade" role="dialog">
      <div class="modal-dialog profile-confirm-poup">
        <!-- Modal content-->
        <div class="modal-content">
          <div class="modal-header confirmpopup-bgcolor p-0">
            <div class="add-record-title">
              <div>
                <span v-if="$i18n.locale === 'Portuguese'">Compra em andamento</span>
                <span v-else>Purchase is in Progress</span>
              </div>
            </div>
          </div>
          <div class="modal-body confirm-body">
            <div class="subscribe-body pb-24">
              <span v-if="$i18n.locale === 'Portuguese'">Seu pagamento está em andamento. Você pode visualizar a fatura clicando no "<span class="text-bold">Link da fatura</span>". Clique em OK para ser redirecionado e rastrear os detalhes do pagamento na seção correspondente da aba "Cobrança".</span>
              <span v-else>Your payment is in progress. You can view the invoice by clicking on the “<span class="text-bold">Invoice link</span>”. Click on "OK" to be redirected to track your payment details in payment tracker section under "Billing" Tab.</span>
              <div class="font-bold pt-16">{{$i18n.locale === 'Portuguese'?'ID de Pagamento':'Payment ID'}}:</div>
              <div>{{ paymentDetails.id }}</div>
            </div>
            <div>
          </div>
          </div>
          <div class="modal-footer confirmpopup-bgcolor col-xs-12 col-sm-12 d-flex-sm-end">
            <div class="">
              <a type="button" class="btn btn-block cancel-changes" :href="paymentDetails.invoice_url" target="_blank">
                <img src="/static/images/icons/invoice_link.svg" />
                {{ $t("invoiceLink") }}
              </a>
            </div>
            <div class="">
              <button type="button" class="btn btn-block proceed-changes" @click="subscribe()">OK</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </template>
<script>
import $ from 'jquery';

export default {
  props: [
    'paymentDetails'
  ],
  data() {
    return {};
  },
  methods: {
    closeModal() {
      $('#confirmationPaymentPopup').modal('hide');
      this.$emit('closePopup');
    },
    subscribe() {
      $('#confirmationPaymentPopup').modal('hide');
      this.$emit('closePopup');
      this.$router.push('/layout/account-settings?page=billing');
    },
  },
};
</script>
  <style scoped>
  label {
      display: inline-block;
      max-width: 100%;
      margin-bottom: 0px !important;
      /* font-weight: 700; */
  }
  .modal-header {
      background-color: #ffffff !important;
      border-bottom: 1px solid #d3d3d3 !important;
      border-top-right-radius: 6px!important;
      border-top-left-radius: 6px!important;
  }
  .modal-header .close {
      background: unset;
      opacity: 1;
      line-height: unset;
      width: unset;
      border-radius: unset;
      color: unset;
      background-color: #ffffff !important;
  }
  .add-record-title {
      display: flex;
      justify-content: space-between;
      font-weight: 600;
      font-size: 20px;
      line-height: 27px;
      color: #1a1a1a;
      padding: 12px 0px 11px 16px;
  }
  .close-icon {
      padding-right: 16px;
  }
  .proceed-title {
      font-weight: 600;
      font-size: 16px;
      line-height: 22px;
      color: #333333;
      padding: 16px 0 23px 0;
  }
  .modal-body {
      padding: 25px 55px 24px 24px;
  }
  .market-title {
      font-weight: 400;
      font-size: 16px;
      line-height: 26px;
      color: #3e3e3e;
  }
  label>input[type="radio"] {
      display: none;
  }
  label>input[type="radio"]+*::before {
      content: "";
      display: inline-block;
      vertical-align: bottom;
      width: 18px;
      height: 18px;
      margin-right: 11px;
      margin-bottom: 4px;
      border-radius: 50%;
      border-style: solid;
      border-width: 1px;
      border-color: #00518a;
      border: 2px solid #4d4d4d;
  }
  label>input[type="radio"]:checked+*::before {
      background: radial-gradient(#00518a 0%, #00518a 46%, transparent 51%, transparent);
      border-color: #00518a;
      border: 2px solid #00518a;
  }
  .proceed-changes,
  .proceed-changes:hover {
      background-color: #01518a;
      height: 44px;
      width: auto;
      color: #ffffff;
      font-size: 18px;
      font-weight: 600;
      border-radius: 3px;
      line-height: 22px;
      float: right;
      cursor: pointer;
      padding: 9px 16px;
      text-transform: capitalize;
  }
  .cancel-changes,
  .cancel-changes:hover {
      background-color: #ffffff;
      height: 44px;
      width: auto;
      color: #000;
      font-size: 18px;
      font-weight: 600;
      border-radius: 3px;
      line-height: 22px;
      float: right;
      cursor: pointer;
      padding: 9px 16px;
      border: 1px solid #000001;
  }
  .download-btn, .download-btn:hover {
    background: transparent;
    font-size: 14px;
    color: #00518A;
    cursor: pointer;
  }
  .col-gap-8 {
    column-gap: 8px;
  }
  .modal-footer {
      background-color: #ffffff !important;
      padding-right: 0px;
      border: none !important;
      border-bottom-right-radius: 6px;
      border-bottom-left-radius: 6px;
  }
  .modal-content {
   border: none;
   border-top-right-radius: 6px!important;
   border-top-left-radius: 6px!important;
   border-bottom-right-radius: 0!important;
   border-bottom-left-radius: 0!important;
  }
  .pb-21 {
   padding-bottom: 21px;
  }
  .radio-buttons {
   padding-left: 19px;
   padding-bottom: 27px;
  }
  @media (min-width: 768px) {
  .modal-dialog {
   width: 700px;
   margin: 30px auto;
  }
  }
  .subscribe-body {
    font-size: 18px;
    color: #333333;
    font-weight: 400;
    font-style: normal;
    line-height: 25px;
  }
  </style>
